import type { CloudTrialState } from "@board-preserve/contracts";

type FormatDate = (value: string) => string;

export function cloudTrialAvailabilityLabel(
  trial: CloudTrialState,
  now = new Date(),
  formatDate: FormatDate = (value) => new Date(value).toLocaleString(),
): string {
  if (trial.status !== "consumed") {
    return "Trial backup will expire 48 hours after it finishes";
  }

  return Date.parse(trial.expiresAt) > now.getTime()
    ? `You can download it until ${formatDate(trial.expiresAt)}.`
    : `It expired on ${formatDate(trial.expiresAt)} and can no longer be downloaded.`;
}
